import React, { useState, useContext } from "react";
import DefaultActionButtonGenerator, {
    ACTION_BUTTON_TYPES as ABT,
    pushToParams,
    addActiveFn,
    withNewTitleAndName
} from "../../../components/action-buttons/ActionButtonGenerator";

import ListComponent from "../../../components/list/ListComponent";
import { useTranslation } from "react-i18next"; /* Added Line */
import { Accordion, Button, Card, Nav, Tab } from "react-bootstrap";
import Filters from "../../../components/list/Filters";
import TextInput from "../../../components/form-fields/TextInput";
import Select from "../../../components/form-fields/Select";
import CrudMain from "../../../components/crud/CrudMain";
import { Field, Form, Formik } from 'formik';
import ReactDatePicker from "../../../components/form-fields/ReactDatePicker";

DemandListReports.propTypes = {};

function DemandListReports(props) {

    const [t] = useTranslation(); /* Added Line */
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(false);
    const [status, setStatus] = useState(-1);

    const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
        useState("");
    const [filters, setFilters] = useState([]);
    const [configData, setConfigData] = useState(null);
    const [refreshList, setRefreshList] = useState(false);
    const [subRefreshList, setSubRefreshList] = useState(false);
    const [dateFilters, setDateFilters] = useState();


    const onUpdateButtonClicked = (selectedRow) => {
        setStatus(0);
        setShowModal(true);
        setSelectedRow(selectedRow);

    }
    const linkFollow = (cell, row, rowIndex, formatExtraData) => {
        return (
            <Button className="btn-xs"
                onClick={() => {
                    onUpdateButtonClicked(row);
                }}
            >
                <i className="fa fa-search color-white"></i>
            </Button>
        );
    };

    const columns = [
        {
            dataField: "id",
            text: t("table.glasIslemNo"),
            sort: true
        },
        {
            dataField: "company.companyGroupNames",
            text: t("table.grupSirketi"),
            sort: true
        },
        {
            dataField: "talepTur.talepTuru",
            text: t("table.talep"),
            sort: true
        },
        {
            dataField: "konu",
            text: t("table.konu"),
            sort: true
        },
        {
            dataField: "isGucuBirimi.descr",
            text: t("table.isGucuBirim"),
            sort: true
        },
        {
            dataField: "cdate",
            text: t("table.baslamaTarihi"),
            sort: true
        },
        {
            dataField: "createdUserFullName",
            text: t("table.sorumluAdi"),
            sort: true

        },
    ];

    const getDetailsTable = (status) => {
        return (
            <ListComponent
                refreshList={subRefreshList}
                entityName=""
                hideSelection={true}
                endpoint="is-yogunlugu-ozet/detay-listele"
                keyField="id"
                customBody={{
                    others: {
                        avukatId: selectedRow.avukat.id,
                        talepDurumNo: status
                    },
                    filters: dateFilters
                }}
                columns={columns}
            />
        );
    }

    return (
        <div className="row">
            <CrudMain
                showModal={showModal}
                setShowModal={setShowModal}
                title={t("sidebar.details")}
                hideNewAddButton
                size={"xl"}
            >

                <Accordion
                    className="accordion accordion-rounded-stylish accordion-bordered"
                    defaultActiveKey="0"
                >
                    <div className="accordion__item" key={"filter"}>
                        <Accordion.Toggle
                            as={Card.Text}
                            eventKey={"filter"}
                            className={`accordion__header ${activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                                } accordion__header--primary`}
                            onClick={() =>
                                setActiveIndicatorInLeftPosition(
                                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                                )
                            }
                        >
                            <span className="accordion__header--icon"></span>
                            <span className="accordion__header--text">
                                {t("sozlesmeler.filtreleme")}
                            </span>
                            <span className="accordion__header--indicator"></span>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={"filter"} className="accordion__body">
                            <div className="accordion__body--text">
                                <Formik
                                    initialValues={{}}
                                    onSubmit={(values, actions) => {
                                        const { startDate, endDate } = values;
                                        setDateFilters([
                                            {
                                                "fieldName": "baslangicTarihi",
                                                "value": startDate,
                                                "oper": "CONTAINS",
                                                "joinEntity": null,
                                                "type": null
                                            },
                                            {
                                                "fieldName": "talepBitisTarihi",
                                                "value": endDate,
                                                "oper": "CONTAINS",
                                                "joinEntity": null,
                                                "type": null
                                            }
                                        ]
                                        )
                                    }}
                                >
                                    {
                                        ({ setFieldValue, handleSubmit, isSubmitting, resetForm }) => {
                                            return (
                                                <Form key={"dateFormFormikForm"}>
                                                    <div className="row">
                                                        <Field
                                                            name="startDate"
                                                            label={t("ihtarnameler.baslangicTarihi")}
                                                            colNumber="4"
                                                            component={ReactDatePicker}
                                                        />
                                                        <Field
                                                            name="endDate"
                                                            label={t("ihtarnameler.bitisTarihi")}
                                                            colNumber="4"
                                                            component={ReactDatePicker}
                                                        />
                                                    </div>
                                                    <button
                                                        key={"submitButton"}
                                                        className="submit btn btn-primary btn-sm"
                                                        type="button"
                                                        onClick={(e) => {
                                                            setSubRefreshList(!subRefreshList);
                                                            handleSubmit()
                                                        }}
                                                    >
                                                        {t("sozlesmeler.filtrele")}
                                                    </button>
                                                    <button
                                                        key={"resetButton"}
                                                        className="submit btn btn-outline-info btn-sm ml-2"
                                                        onClick={resetForm}
                                                    >
                                                        {t("actionButtonGenerator.formuTemizle")}
                                                    </button>
                                                </Form>
                                            );
                                        }
                                    }
                                </Formik>

                            </div>
                        </Accordion.Collapse>
                    </div>
                </Accordion>

                <Tab.Container defaultActiveKey={"Bekleyenler"}>

                    <Nav as="ul" className="nav-tabs">
                        <Nav.Item as="li" key={1}>
                            <Nav.Link onClick={() => setStatus(0)} eventKey={"Bekleyenler"}>{t("tabs.Bekleyenler")}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li" key={2}>
                            <Nav.Link onClick={() => setStatus(1)} eventKey={"Yonelendirilmis"}>
                                {t("tabs.YonlendirilmisTalepler")}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li" key={3}>
                            <Nav.Link onClick={() => setStatus(2)} eventKey={"Devam"}>
                                {t("tabs.DevamEdenTalepler")}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li" key={4}>
                            <Nav.Link onClick={() => setStatus(3)} eventKey={"Tammam"}>
                                {t("tabs.TammamlanimisTalepler")}
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey={"Bekleyenler"} key={1}>
                            {selectedRow && getDetailsTable(0)}
                        </Tab.Pane>
                        <Tab.Pane eventKey={"Yonelendirilmis"} key={2}>
                            {selectedRow && getDetailsTable(1)}
                        </Tab.Pane>
                        <Tab.Pane eventKey={"Devam"} key={3}>
                            {selectedRow && getDetailsTable(2)}
                        </Tab.Pane>
                        <Tab.Pane eventKey={"Tammam"} key={4}>
                            {selectedRow && getDetailsTable(3)}
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </CrudMain>
            <div className="col-md-12 mt-3">
                <Accordion
                    className="accordion accordion-rounded-stylish accordion-bordered"
                    defaultActiveKey="0"
                >
                    <div className="accordion__item" key={"filter"}>
                        <Accordion.Toggle
                            as={Card.Text}
                            eventKey={"filter"}
                            className={`accordion__header ${activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                                } accordion__header--primary`}
                            onClick={() =>
                                setActiveIndicatorInLeftPosition(
                                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                                )
                            }
                        >
                            <span className="accordion__header--icon"></span>
                            <span className="accordion__header--text">
                                {t("sozlesmeler.filtreleme")}
                            </span>
                            <span className="accordion__header--indicator"></span>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={"filter"} className="accordion__body">
                            <div className="accordion__body--text">
                                <Filters
                                    configPointUrl="raporlar/config"
                                    //configReqType={"POST"}
                                    setConfigData={(data) => setConfigData(data)}
                                    setFilters={setFilters}
                                    setRefreshList={setRefreshList}
                                    refreshList={refreshList}
                                >
                                    <Field
                                        name="fullName"
                                        label={t("davaIcraSavcilik.kullaniciadi")}
                                        colNumber="3"
                                        component={TextInput}
                                    />
                                    <Field
                                        name="userStatus"
                                        label={t("demandList.durum")}
                                        oper="EQ"
                                        colNumber="3"
                                        component={Select}
                                        options={configData && configData.sirketDurumu}
                                    />
                                </Filters>
                            </div>
                        </Accordion.Collapse>
                    </div>
                </Accordion>
            </div>
            <div className="col-md-12">
                <ListComponent
                    entityName=""
                    endpoint="is-yogunlugu-ozet/listele"
                    keyField="id"
                    hideSelection={true}
                    refreshList={refreshList}
                    customBody={{
                        // talepTurId: props.talepTurId,
                        pageSize: 10,
                        pageIndex: 0,
                        sortOrder: "DESC",
                        sortColumn: "atananSayisi",
                        filters: filters
                    }}
                    columns={[
                        {
                            dataField: "avukat.fullName",
                            text: `${t("demandList.KullaniciAdi")}`,
                            sort: true,
                        },
                        {
                            dataField: "bekleyenSayisi",
                            text: `${t("demandList.bekleyenSayisi")}`,
                            sort: true,
                        },
                        {
                            dataField: "atananSayisi",
                            text: `${t("demandList.atananSayisi")}`,
                            sort: true,
                        },
                        {
                            dataField: "devamEdenSayisi",
                            text: `${t("demandList.devamEdenSayisi")}`,
                            sort: true,
                        },
                        {
                            dataField: "tamamlanmisSayisi",
                            text: `${t("demandList.tamamlananlarSayisi")}`,
                            sort: true,
                        },
                        {
                            dataField: "avukat.stId",
                            text: `${t("demandList.durum")}`,
                            sort: true,
                            formatter: (val) => { return val === 90 ? `${t("demandList.durumAktif")}` : `${t("demandList.durumPasif")}` }
                        },
                        {
                            dataField: "",
                            text: `${t("operations")}`,
                            formatter: linkFollow,
                            sort: false,
                        },
                    ]}
                    actionButtonsObject={{
                        actions: [
                            addActiveFn(
                                pushToParams(
                                    withNewTitleAndName(
                                        ABT.EDIT,
                                        "Görüntüle",
                                        "EDIT_WITH_TITLE"
                                    ),
                                    onUpdateButtonClicked
                                ),
                                (row) => !row.departmanYoneticisiMi
                            ),
                            addActiveFn(
                                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                                (row) => {
                                    return row.departmanYoneticisiMi
                                }
                            ),
                            pushToParams(ABT.EXCEL_EXPORT, {
                                requestTo: "file/download-excel-isyogunlugu"
                            }),
                        ],
                        generator: DefaultActionButtonGenerator,
                    }}
                />
            </div>
        </div>
    );
}

export default DemandListReports;
